export function onDocumentClick(onClick: (evt: globalThis.MouseEvent) => void) {
    return () => {
        if (typeof window !== 'undefined') {
            document.addEventListener('mousedown', onClick);
        }

        return () => {
            if (typeof window !== 'undefined') {
                document.removeEventListener('mousedown', onClick);
            }
        };
    };
}
